<template>
  <b-container>
    <b-form v-on:submit.prevent enctype="multipart/form-data">
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col cols="3">
                <b-form-group label="Origin" label-for="origin">
                  <v-select
                    id="origin"
                    v-model="form.selectedOrigin"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsOrigin"
                    placeholder="Select 1 Origin"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedOrigin"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedOrigin }}</strong> -->
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="Destination" label-for="destination">
                  <v-select
                    id="destination"
                    v-model="form.selectedDestination"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsDestination"
                    placeholder="Select 1 Destination"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedDestination"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedDestination }}</strong> -->
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Description" label-for="description">
                  <b-form-textarea
                    id="description"
                    placeholder="Description"
                    v-model="form.description"
                    class="form-control"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <b-row>
              <b-col>
                <label for="items" class="text-primary font-weight-bolder mb-1"
                  >Items</label
                >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  v-b-modal.modal-add
                  class="float-right mb-2"
                  >Add Item
                </b-button>
              </b-col>
            </b-row>
            <b-modal
              id="modal-add"
              ref="modal-add"
              centered
              title="Add Item"
              hide-footer
            >
              <b-row>
                <b-col cols="12">
                  <b-form-group label="Product" label-for="product">
                    <v-select
                      id="product"
                      v-model="form2.selectedProduct"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="text"
                      :options="form2.optionsProduct"
                      placeholder="Select 1 Product"
                      :disabled="form.selectedOrigin ? false : true"
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          :required="!form2.selectedProduct"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-select>
                    <!-- Selected: <strong>{{ form2.selectedProduct }}</strong> -->
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group label="Qty" label-for="qty">
                    <b-form-input
                      id="qty"
                      placeholder="Qty"
                      v-model="form2.qty"
                      type="number"
                      required
                      :disabled="form.selectedOrigin ? false : true"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="my-1"
                    block
                    @click="addItemToTable()"
                    :disabled="form.selectedOrigin ? false : true"
                  >
                    Add Item
                  </b-button>
                </b-col>
              </b-row>
            </b-modal>
            <b-row>
              <b-col md="12">
                <!-- table -->
                <vue-good-table
                  :columns="columns"
                  :rows="rows"
                  :rtl="direction"
                  :search-options="{
                    enabled: true,
                    externalQuery: searchTerm,
                  }"
                  :select-options="{
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    disableSelectInfo: true, // disable the select info panel on top
                    selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: pageLength,
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Name -->
                    <span
                      v-if="props.column.field === 'name'"
                      class="text-nowrap"
                    >
                      <!-- <b-avatar
                                    :src="props.row.avatar"
                                    class="mx-1"
                                /> -->
                      <span class="text-nowrap">{{ props.row.name }}</span>
                    </span>

                    <!-- Column: Image -->
                    <span
                      v-else-if="props.column.field === 'image'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap"
                        ><img :src="props.row.image" alt="items" width="50"
                      /></span>
                    </span>

                    <!-- Column: Price -->
                    <span
                      v-else-if="props.column.field === 'price'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap">Rp {{ props.row.price }}</span>
                    </span>

                    <!-- Column: Status -->
                    <span v-else-if="props.column.field === 'status'">
                      <b-badge :variant="statusVariant(props.row.status)">
                        <span v-if="props.row.status === 1">Active</span>
                        <span v-else>Non-Active</span>
                      </b-badge>
                    </span>

                    <!-- Column: Action -->
                    <span v-else-if="props.column.field === 'action'">
                      <span>
                        <b-dropdown
                          variant="link"
                          toggle-class="text-decoration-none"
                          no-caret
                        >
                          <template v-slot:button-content>
                            <feather-icon
                              icon="MoreVerticalIcon"
                              size="16"
                              class="text-body align-middle mr-25"
                            />
                          </template>
                          <b-dropdown-item
                            @click="
                              deleteItemFromTable(props.row.originalIndex)
                            "
                          >
                            <feather-icon icon="TrashIcon" class="mr-50" />
                            <span>Delete</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </span>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>

                  <!-- pagination -->
                  <template slot="pagination-bottom" slot-scope="props">
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Showing 1 to </span>
                        <b-form-select
                          v-model="pageLength"
                          :options="['3', '5', '10']"
                          class="mx-1"
                          @input="
                            (value) =>
                              props.perPageChanged({ currentPerPage: value })
                          "
                        />
                        <span class="text-nowrap">
                          of {{ props.total }} entries
                        </span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="props.total"
                          :per-page="pageLength"
                          first-number
                          last-number
                          align="right"
                          prev-class="prev-item"
                          next-class="next-item"
                          class="mt-1 mb-0"
                          @input="
                            (value) => props.pageChanged({ currentPage: value })
                          "
                        >
                          <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                          </template>
                          <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                          </template>
                        </b-pagination>
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-card>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            @click="validation()"
            block
          >
            Submit
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import {
  BFormTextarea,
  BDropdownItem,
  BDropdown,
  BBadge,
  BPagination,
  BFormFile,
  BImg,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BModal,
  VBModal,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ImageUploader from "vue-image-upload-resize";
import { $themeConfig } from "@themeConfig";
import Cleave from "vue-cleave-component";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";

export default {
  components: {
    VueGoodTable,
    ToastificationContent,
    vSelect,
    ImageUploader,
    Cleave,
    BFormTextarea,
    BPagination,
    BBadge,
    BDropdownItem,
    BDropdown,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BImg,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
    BModal,
    VBModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        selectedOrigin: null,
        optionsOrigin: [],
        selectedDestination: null,
        optionsDestination: [],
        description: "",
      },
      form2: {
        selectedProduct: null,
        optionsProduct: [],
        qty: null,
        transfer_id: null,
      },
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      image: "",
      photo: "",
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: "Image",
          field: "image",
        },
        {
          label: "Code",
          field: "code",
        },
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Qty",
          field: "qty",
        },
        {
          label: "Unit",
          field: "unit_name",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      rows: [],
      searchTerm: "",
      errors: "",
      errMessage: "",
    };
  },
  watch: {
    "form.selectedOrigin": function (data) {
      this.form2.selectedProduct = null;
      this.form2.qty = null;
      this.rows.splice(0);
      this.getProduct(data.value);
    },
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  created() {
    this.getWarehouse();
  },
  methods: {
    getWarehouse() {
      this.$http.get("warehouses").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsOrigin.push($data);
          this.form.optionsDestination.push($data);
        }
        // console.log(this.form.optionsVendor)
      });
    },
    getProduct($originID) {
      this.$http.get("warehouse/" + $originID + "/items").then((response) => {
        // console.log(response.data.data)
        this.form2.optionsProduct.splice(0);
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          const { baseUrl } = $themeConfig.app;
          this.photo = baseUrl;
          this.photo += "storage/product/";
          this.photo += datas[i].product_image;

          var $data = {
            value: datas[i].id,
            text: datas[i].product_name,
            code: datas[i].code,
            unit: datas[i].unit_name,
            urlImage: this.photo,
          };
          // console.log($data)
          this.form2.optionsProduct.push($data);
        }
        // console.log(this.form2.optionsProduct)
      });
    },
    addItemToTable() {
      this.$refs["modal-add"].hide();
      if (this.form2.selectedProduct === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Product field is required",
            variant: "warning",
          },
        });
      } else if (this.form2.qty === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Qty field is required",
            variant: "warning",
          },
        });
      } else {
        var $data = {
          id: this.form2.selectedProduct.value,
          image: this.form2.selectedProduct.urlImage,
          code: this.form2.selectedProduct.code,
          name: this.form2.selectedProduct.text,
          unit_name: this.form2.selectedProduct.unit,
          qty: this.form2.qty,
        };
        this.rows.push($data);
      }
    },
    deleteItemFromTable(index) {
      this.rows.splice(index, 1);
    },
    validation() {
      if (this.form.selectedOrigin === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Origin field is required",
            variant: "warning",
          },
        });
      } else if (this.form.selectedDestination === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Destination field is required",
            variant: "warning",
          },
        });
      } else {
        this.addTransfer();
      }
    },
    addTransfer() {
      if (this.form.selectedOrigin !== null) {
        var $origin = this.form.selectedOrigin.value;
      }
      if (this.form.selectedDestination !== null) {
        var $destination = this.form.selectedDestination.value;
      }
      this.$http
        .post("warehouse/transfer/add", {
          origin: $origin,
          destination: $destination,
          description: this.form.description,
        })
        .then((response) => {
          this.form2.transfer_id = response.data.data.id;
          var $datas = this.rows;
          var i;
          for (i = 0; i < $datas.length; i++) {
            var $data = {
              item_id: $datas[i].id,
              qty: $datas[i].qty,
            };
            // console.log($data)
            this.addTransferItems($data);
          }
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success add Transfer",
              variant: "success",
            },
          });
          setTimeout(function () {
            location.href = "/warehouse/transfer";
          }, 2000);
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    addTransferItems($data) {
      this.$http
        .post(
          "warehouse/transfer/" + this.form2.transfer_id + "/item/add",
          $data
        )
        .then((response) => {
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>

<style>
#purchase div img.img-preview {
  width: 200px;
  padding-right: 10px;
}
</style>